import { useMutation } from "@tanstack/react-query";
import { UsersApi } from "@/openapi/generated";
import type { ForgotPasswordFormSchema } from "@/schemas";

import { createOpenApiConfiguration } from "@/lib/utils";

export type ForgotPasswordFormType = ForgotPasswordFormSchema & {
  clientBaseUrl: string;
};

export const useAuthForgotPassword = (
  toast: ReturnType<typeof import("@/components/feedback").useToast>,
) => {
  const service = new UsersApi(createOpenApiConfiguration());

  const { mutate, isPending, isError, isSuccess } = useMutation({
    mutationFn: async (data: ForgotPasswordFormType) => {
      return service.apiUserAuthForgotPasswordPost({
        forgotPasswordRequest: {
          email: data.email,
          clientBaseUrl: data.clientBaseUrl!,
        },
      });
    },
    onSuccess: (data, variables) => {
      toast({
        title: "Email sent",
        description: `Password reset link sent to ${variables.email}`,
        status: "success",
        duration: 3000,
        isClosable: true,
        position: "top-right",
      });
    },
    onError: (error: any, variables) => {
      const errorMessage =
        error instanceof Error
          ? error.message
          : "Failed to send reset link";
      
      toast({
        title: "Error",
        description: errorMessage,
        status: "error",
        duration: 3000,
        isClosable: true,
        position: "top-right",
      });
    },
  });

  return { mutate, isPending, isError, isSuccess };
};
